import { render, staticRenderFns } from "./InformedConsentShow.vue?vue&type=template&id=798662b0&"
import script from "./InformedConsentShow.vue?vue&type=script&lang=js&"
export * from "./InformedConsentShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports